// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-line-multi"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.5 5.5L15.5 10.5L11.5 6.5L6.5 11.5M20.5 10.5L15.5 15.5L11.5 11.5L6.5 16.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartLineMultiIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-line-multi',
    ref,
    icon: element,
  },
));

ChartLineMultiIcon.displayName = 'ChartLineMultiIcon';

export default ChartLineMultiIcon;
